export default __webpack_public_path__ + "images/logo-keffplus-en.svg?6ec0e7acfd49112c4ee1a1018e3dd640";